module.exports = __webpack_public_path__ + "img/el-ic-video.27334ece.svg";